<template>
	<div class="cus-g-container cus-pinmycom"> 
		<i class="commicon cus-icon">&#xe603;</i> 
		<span>品迈科技</span>
	</div>
</template>

<script>
	 
	export default{
		name:'PinMyCom',
		components:{},
		data(){
			return{  
				 
			}
		},
		props: {
		  //msg: String
		},
		created() { 
			
		},
		mounted() { 
			 
		},
		methods:{ 
			
		}
	}
</script>

<style scoped="scoped">
	.cus-pinmycom{
		background-color: rgba(0, 0, 0, .7);
		color: rgba(0, 0, 0, .1);
		font-size: 12px;
		letter-spacing: 3px; 
		height: 40px;
		line-height: 40px;
		background-color: transparent; 
		display: flex;
		justify-content: center;
		align-items: center; 
		box-sizing: border-box;   
		font-size: 12px;
	} 
	.cus-icon{ 
		
		/** 
		background-image: linear-gradient(120deg, rgba(136, 89, 255, .5) 0%, rgba(92, 163, 253, .5) 100%);
		**/ 
		background-color: #DDDDDD;
		width: 20px;
		height: 20px;
		line-height: 20px;
		border-radius: 50%;
		color: rgba(255, 255, 255, 1);
		font-size: 20px; 
		margin-right: 5px;
	}
</style>
 